import type { CopilotProposalId } from "@repo/app-types/entities/copilotProposal";
import type { PlaybookId } from "@repo/app-types/entities/playbook";
import type { Project } from "@repo/app-types/entities/project";
import type { TeammateId } from "@repo/app-types/entities/teammate";
import { api } from "../redux.js";

const trainingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createTrainingProject: builder.mutation<
      {
        data: {
          project: Project;
        };
      },
      {
        name: string;
        short_id: string;
        owner_teammate_ids: readonly TeammateId[];
        playbook_id: PlaybookId;
        proposal_id?: CopilotProposalId;
      }
    >({
      query: (payload) => ({
        url: "/training",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const { useCreateTrainingProjectMutation } = trainingApi;
